/*
  vuex相关通用方法mix by.qiushangzhe 2020-01-22
*/

// 首先是跟登录的用户相关的数据
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      courseTypeList: state => state.extendInfoModule.vuexSummaryInfo ? state.extendInfoModule.vuexSummaryInfo.type : null,
      directionList: state => state.extendInfoModule.vuexSummaryInfo ? state.extendInfoModule.vuexSummaryInfo.direction : null,
      fitList: state => state.extendInfoModule.vuexFitInfo
    }),
    ...mapGetters({
      isLogin: 'userInfoModule/isLogin'
    }),
    isInit () {
      return this.teacherList && this.producorLeaderList && this.courseSummaryInfo
    }
  },
  methods: {
    // 在 `some/nested/module` 中查找
    ...mapActions({
      initUserInfo: 'userInfoModule/initUserInfo',
      initExtendInfo: 'extendInfoModule/initExtendInfo'
    })
  }
}
